export default {
  model: [
    {
      label: 'Título',
      field: 'title',
      type: 'text'
    },
    {
      label: 'Chamada',
      field: 'short_title',
      type: 'text'
    },
    {
      label: 'Text',
      field: 'content',
      type: 'text'
    },
    {
      label: 'Data de publicação no site',
      field: 'news_date',
      type: 'text'
    }
  ]
}